<template>
  <div class="g-layout">
    <!-- 头部:fixed -->
    <div class="g-layout-header" id="gLayoutHeader">
      <div class="g-layout-header-content">
        <div class="g-layout-header-logo">
          <router-link to="/manage/home">
            <Icon type="logo" />
            <span>{{ $t('com_header_title') }}</span>
          </router-link>
        </div>
        <div class="g-layout-header-right" v-if="userInfo">
          <!-- 只有有设备或站点权限的人才显示搜索 -->
          <div
            class="g-layout-header-search"
            v-auth="[
              'auth_site_header_search',
              'auth_device_header_search',
              'auth_docs_header_search',
            ]"
          >
            <a-popover
              trigger="hover"
              overlayClassName="navbar-link custom-popover-menu custom-popover-noarrow"
              :visible="true"
              v-model="visibleSearch"
              :getPopupContainer="getPopupContainerHeader"
            >
              <template slot="content">
                <SearchContent
                  :value="searchValue"
                  :mouseAction="searchMouseAction"
                  ref="HeaderSearchContent"
                  @close="handleClose"
                />
              </template>
              <div
                class="navbar-search-content"
                @mouseleave="searchMouseAction(true)"
                @mouseenter="searchMouseAction(false)"
              >
                <!-- 搜索 -->
                <a-input-search
                  :placeholder="$t('com_header_search_placeholder')"
                  v-model="searchValue"
                  @search="
                    () => {
                      return false;
                    }
                  "
                  @focus="searchFocus"
                  @change="onChange"
                  allowClear
                  style="text-align: left;"
                >
                </a-input-search>
              </div>
            </a-popover>
          </div>
          <div class="g-layout-header-navbar">
            <!-- 文档 -->
            <a-tooltip
                :title="$t('com_header_document')"
                :getPopupContainer="getPopupContainerHeader"
                v-auth.and="['auth_docs', 'auth_docs_home_list_all']"
            >
              <router-link to="/manage/docs" class="navbar-link">
                <Icon type="graduation" />
              </router-link>
            </a-tooltip>

            <!-- 附件 -->
            <a-tooltip
                :title="$t('attach_menu')"
                :getPopupContainer="getPopupContainerHeader"
                v-auth.and="['auth_attach', 'auth_attach_tree']"
            >
              <router-link to="/manage/attach/list" class="navbar-link">
                <Icon type="menu_log2" />
              </router-link>
            </a-tooltip>

            <!-- 切换语言 -->
            <div class="navbar-link" v-if="showLanguage">
              <a-popover
                trigger="hover"
                overlayClassName="navbar-link custom-popover-menu custom-popover-noarrow"
                :getPopupContainer="getPopupContainerHeader"
              >
                <template slot="content">
                  <LanguageMenu />
                </template>
                <div class="navbar-link-content">
                  <Icon type="language" />
                </div>
              </a-popover>
            </div>

            <!-- 消息提醒 -->
            <a-tooltip
              :title="$t('com_header_message')"
              :getPopupContainer="getPopupContainerHeader"
              v-auth.and="['auth_message', 'auth_message_list']"
            >
              <router-link
                to="/manage/message/list"
                class="navbar-link"
              >
                <Icon type="message" />
                <span class="navbar-link-message" v-if="messageUnreadNum && messageUnreadNum > 0">
                  {{ messageUnreadNum > 99 ? '99+' : messageUnreadNum }}
                </span>
              </router-link>
            </a-tooltip>

            <!-- 设置 -->
            <a-tooltip
              :title="$t('com_header_setting')"
              :getPopupContainer="getPopupContainerHeader"
              v-auth="['auth_system']"
            >
              <router-link
                :to="{ name: 'SystemDashboard' }"
                v-if="hasSystemDashboard"
                class="navbar-link"
              >
                <Icon type="setting2" style="color:#000;" />
              </router-link>

              <router-link :to="{ name: 'SystemWelcome' }" v-else class="navbar-link">
                <Icon type="setting2" style="color:#000;" />
              </router-link>
            </a-tooltip>

            <!-- 退出登录及帐号信息 -->
            <div class="navbar-link navbar-user" v-if="userInfo && userInfo.user">
              <a-popover
                trigger="hover"
                overlayClassName="navbar-link custom-popover-menu custom-popover-noarrow "
                :getPopupContainer="getPopupContainerHeader"
              >
                <template slot="content">
                  <UserMenu />
                </template>

                <div class="navbar-link-content" style="overflow: hidden;">
                  <img :src="`${avatarUrl}`" v-if="isAvatarOK" style="width:100%;height:100%" />
                  <Icon type="logo2" v-else />
                </div>
              </a-popover>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="g-layout-container">
      <!-- 左侧 -->
      <div class="g-layout-sider" :class="{ 'g-layout-sider-admin': isManagePage }">
        <div class="g-layout-sider-content">
          <!-- 导航:fixed -->
          <div class="g-layout-sider-menu-wrapper">
            <!-- 圆角 -->
            <!-- <div class="g-layout-circle-left"></div>
            <div class="g-layout-circle-right"></div> -->
            <Sider v-if="isManagePage" :menu="sidebarMenuForAdmin" />
            <Sider v-else :menu="sidebarMenuForCustomer" />
          </div>
        </div>
      </div>

      <div class="g-layout-right">
        <!-- 导航 -->
        <div
          class="g-layout-right-history"
          :class="{ 'g-layout-right-history-admin': isManagePage }"
        >
          <!-- 圆角 -->
          <!-- <div class="g-layout-circle-left"></div>
          <div class="g-layout-circle-right"></div> -->
          <div class="g-layout-right-history-content">
            <RouteHistory />
          </div>
        </div>

        <!-- 右则 -->
        <div class="g-layout-main-wrapper">
          <div class="g-layout-main" :class="{ 'g-layout-main-loading': pageLoading }">
            <!-- 内容区域 -->
            <!-- <Breadcrumb v-if="!['Home', 'Welcome'].includes(this.$route.name)" /> -->
            <Loading :show.sync="pageLoading" v-show="pageLoading" />
            <!-- 网络错误 -->
            <router-view v-show="!pageLoading" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Sider from '@/components/Layout/Sider';
import { mapState } from 'vuex';
import Config from '@/config';
import UserMenu from './components/UserMenu';
import LanguageMenu from './components/LanguageMenu.vue';
import SearchContent from './components/SearchContent.vue';
import { MessageUnread } from '@/api/message';
import RouteHistory from './components/RouteHistory';
import { generateSignedUrl } from '@/config/oss';
import { debounce } from '@/libs/utils';

export default {
  components: { Sider, UserMenu, LanguageMenu, SearchContent, RouteHistory },
  data() {
    return {
      debounce,
      config: Config,
      // 搜索关键字
      searchValue: '',
      // 显示
      visibleSearch: false,
      // 鼠标是否离开搜索区域
      mouseLeaveFromSearch: false,

      avatarUrl: '',

      searchTimer: null,

      // 头像图片是否能加载
      isAvatarOK: false,
      clickClose: false,

      // 显示语言切换按钮
      showLanguage: false,
    };
  },
  computed: {
    ...mapState([
      'sidebarMenuForCustomer',
      'sidebarMenuForAdmin',
      'userInfo',
      'networkError',
      'authList',
      'isSuperAdmin',
      'messagePollingTime',
      'isStayMessagePage',
      'historyRouteList',
      'messageUnreadNum',
    ]),

    // 是否管理界面
    isManagePage() {
      return this.$route.path.indexOf('/manage/system') > -1;
    },

    // 是否有system dashboard权限
    hasSystemDashboard() {
      return this.authList.includes('auth_system_dashboard');
    },

    pageLoading: {
      get() {
        return this.$store.state.pageLoading;
      },
      set(val) {
        this.$store.commit('setPageLoading', val);
      },
    },
  },
  created() {
    // 环境变量VUE_APP_LANGUAGE_SWITCH控制语言切换按钮的显示
    this.showLanguage = process.env.VUE_APP_LANGUAGE_SWITCH === 'true';
  },

  async mounted() {
    document.addEventListener('click', this.documentClick);
    // 获取消息数量
    this.getMessageNum();

    // 获取头像
    await this.getUrl();
  },
  beforeDestroy() {
    document.removeEventListener('click', this.documentClick);
  },
  watch: {
    isStayMessagePage() {
      this.getMessageNum();
    },
  },
  methods: {
    handleClose() {
      this.clickClose = true;
      this.visibleSearch = false;
      return false;
    },
    async getUrl() {
      if (this.userInfo && this.userInfo.user && this.userInfo.user.avatar) {
        this.avatarUrl = await generateSignedUrl({ objectKey: this.userInfo.user.avatar });
        this.checkImage(this.avatarUrl);
      }
    },

    // 点击其他区域隐藏搜索框
    documentClick() {
      if (this.mouseLeaveFromSearch || this.clickClose) {
        this.visibleSearch = false;
      }
    },
    // 搜索
    onChange() {
      if (this.searchValue) {
        this.visibleSearch = true;
        if (this.searchTimer) {
          clearTimeout(this.searchTimer);
        }
        this.searchTimer = setTimeout(() => {
          this.$refs.HeaderSearchContent?.clickTab();
        }, 700);
      } else {
        this.$refs.HeaderSearchContent?.reset();
      }
    },
    searchFocus() {
      // if (this.searchValue) {
      this.visibleSearch = true;
      // }
    },
    // 鼠标移入移出搜索区域
    searchMouseAction(status) {
      this.mouseLeaveFromSearch = status;
    },

    // 获取消息数量
    getMessageNum() {
      if (this.isStayMessagePage) {
        return;
      }

      MessageUnread()
        .then(res => {
          if (res.code === 0) {
            // 未读消息数量
            this.$store.commit('setMessageUnreadNum', res.data || 0);
          }
        })
        .finally(() => {
          // 30秒获取一次
          setTimeout(() => {
            this.getMessageNum();
          }, this.messagePollingTime);
        });
    },

    getPopupContainerHeader() {
      return document.getElementById('gLayoutHeader');
    },

    // 检查头像能不能加载
    checkImage(url) {
      const img = new Image();
      img.src = url;
      img.onload = () => {
        this.isAvatarOK = true;
      };
      img.onerror = () => {
        this.isAvatarOK = false;
      };
    },
  },
};
</script>
<style lang="less" scoped>
.g-layout-content-loading {
  position: absolute;
  background: rgba(255, 255, 255, 0.8);
  height: 100%;
  color: #666;
  margin: 0;
  width: 100%;
  padding-top: 200px;
}
</style>
